import { gql } from "@apollo/client";

export const GridViewList = gql`
    query GridViewList ($search: SearchInput, $filter: GridViewListFilter, $pagination: Pagination){
        gridViewList(
            search: $search,
            filter: $filter
        ) {
            total
            gridViews(pagination: $pagination) {
                id
                title
                rotationTime
                assetCount
                client {
                    id
                    name
                }
            }
        }
    }
`;
